export const SITE = {
  name: "Adipurusa Infotech",
  legalName: "Adipurusa Infotech Private Limited",
  phone: "+91 9063428151",
  phoneHref: "tel:+919063428151",
  email: "info@adipurusainfotech.com",
  address:
    "Flat No. 501, 5th Floor, Aryamithra Aerium Apartments, Alkapur Town, Rangareddy, Telangana, 500089, India",
};

export const COURSES = [
  {
    track: "Track 01",
    name: "Artificial Intelligence",
    blurb: "LLMs, Neural Networks, Computer Vision, and generative models.",
  },
  {
    track: "Track 02",
    name: "Data Science & Analytics",
    blurb: "Python, SQL, Tableau, PowerBI, statistical algorithms, predictive ML.",
  },
  {
    track: "Track 03",
    name: "SAP Enterprise Suite",
    blurb: "SAP S/4HANA, FICO, MM, SD, and live business implementation flows.",
  },
  {
    track: "Track 04",
    name: "Oracle Cloud & DB",
    blurb: "Oracle DBA, PL/SQL, Oracle Cloud Infrastructure architecture.",
  },
  {
    track: "Track 05",
    name: "Microsoft Azure & .NET",
    blurb: "C#, .NET Core, Azure DevOps, cloud serverless microservices.",
  },
];

export const VERTICALS = [
  {
    num: "01",
    title: "Training & Placements",
    blurb:
      "Intensive bootcamps and job-oriented technical programs taught by working enterprise professionals.",
  },
  {
    num: "02",
    title: "Product Development",
    blurb:
      "Scalable custom web, mobile, and cloud software engineering built with modern frameworks and robust security.",
  },
  {
    num: "03",
    title: "IT Services & Consulting",
    blurb:
      "Database tuning, cloud migration, ERP implementation, and dedicated staff augmentation for global companies.",
  },
];

export const SERVICE_OPTIONS = [
  "Product Development",
  "IT Services & Staffing",
  "Corporate Batch Upskilling",
  "Placement Partnership",
];

export const MARQUEE_ITEMS = [
  "ARTIFICIAL INTELLIGENCE",
  "DATA SCIENCE",
  "SAP S/4HANA",
  "ORACLE CLOUD",
  "MICROSOFT AZURE",
  "ENTERPRISE IT DELIVERY",
];

export const ABOUT_IMAGE =
  "https://images.pexels.com/photos/9159042/pexels-photo-9159042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
